import React, { useEffect, useState } from "react";
import PageLayout from "../components/layout/PageLayout";
import PageHero from "../components/shared/PageHero";
import SectionHeading from "../components/shared/SectionHeading";
import SectionDivider from "../components/decor/SectionDivider";
import { SITE } from "../data/site";
import { IMG } from "../data/site";
import { MapPin, Phone, Mail, Clock, Send, Plane, Train, Car, Camera, Info } from "lucide-react";
import { toast } from "sonner";
import { useLang } from "../i18n/LanguageContext";
import { createContactInquiry, fetchRoomTypes } from "../api";

const todayISO = () => new Date().toISOString().slice(0, 10);
const dateToEpoch = (iso) => new Date(`${iso}T00:00:00`).getTime();
const numbersOnly = (value) => value.replace(/\D/g, "");
const SUBJECT_MAX_LENGTH = 50;
const MESSAGE_MAX_LENGTH = 250;

const departments = [
  { name: { en: "General Office", kn: "ಸಾಮಾನ್ಯ ಕಚೇರಿ" }, email: "info@sodevadirajamatha.org", phone: SITE.phone },
  { name: { en: "Temple Administration", kn: "ದೇವಸ್ಥಾನ ಆಡಳಿತ" }, email: "temple@sodevadirajamatha.org", phone: SITE.phone },
  { name: { en: "Donations & Seva", kn: "ದೇಣಿಗೆ ಮತ್ತು ಸೇವೆ" }, email: "seva@sodevadirajamatha.org", phone: SITE.phone },
  { name: { en: "Publications", kn: "ಪ್ರಕಟಣೆಗಳು" }, email: "publications@sodevadirajamatha.org", phone: SITE.phone },
  { name: { en: "Accommodation", kn: "ವಸತಿ" }, email: "stay@sodevadirajamatha.org", phone: SITE.phone },
  { name: { en: "Media Enquiries", kn: "ಮಾಧ್ಯಮ ವಿಚಾರಣೆಗಳು" }, email: "media@sodevadirajamatha.org", phone: SITE.phone },
];

const COPY = {
  name: { en: "Your name", kn: "ನಿಮ್ಮ ಹೆಸರು" },
  email: { en: "Email", kn: "ಇಮೇಲ್" },
  phone: { en: "Phone", kn: "ದೂರವಾಣಿ" },
  selectCategory: { en: "Select Category", kn: "ವರ್ಗ ಆಯ್ಕೆಮಾಡಿ" },
  roomBooking: { en: "Room Booking", kn: "ಕೊಠಡಿ ಕಾಯ್ದಿರಿಸುವಿಕೆ" },
  onlineSeva: { en: "Online Seva", kn: "ಆನ್‌ಲೈನ್ ಸೇವೆ" },
  generalQuery: { en: "General Query", kn: "ಸಾಮಾನ್ಯ ವಿಚಾರಣೆ" },
  members: { en: "Number of Members", kn: "ಸದಸ್ಯರ ಸಂಖ್ಯೆ" },
  visitDate: { en: "Date of Visit", kn: "ಭೇಟಿ ದಿನಾಂಕ" },
  roomType: { en: "Select Room Type", kn: "ಕೊಠಡಿ ಪ್ರಕಾರ ಆಯ್ಕೆಮಾಡಿ" },
  subject: { en: "Subject", kn: "ವಿಷಯ" },
  message: { en: "Your message", kn: "ನಿಮ್ಮ ಸಂದೇಶ" },
  sending: { en: "Sending...", kn: "ಕಳುಹಿಸಲಾಗುತ್ತಿದೆ..." },
  sendMessage: { en: "Send message", kn: "ಸಂದೇಶ ಕಳುಹಿಸಿ" },
  nameError: { en: "Please enter your name.", kn: "ದಯವಿಟ್ಟು ನಿಮ್ಮ ಹೆಸರನ್ನು ನಮೂದಿಸಿ." },
  emailError: { en: "Please enter a valid email.", kn: "ದಯವಿಟ್ಟು ಸರಿಯಾದ ಇಮೇಲ್ ನಮೂದಿಸಿ." },
  phoneError: { en: "Please enter a valid 10 digit mobile number.", kn: "ದಯವಿಟ್ಟು ಸರಿಯಾದ 10 ಅಂಕಿಯ ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ." },
  categoryError: { en: "Please select a category.", kn: "ದಯವಿಟ್ಟು ವರ್ಗವನ್ನು ಆಯ್ಕೆಮಾಡಿ." },
  membersError: { en: "Please enter number of members.", kn: "ದಯವಿಟ್ಟು ಸದಸ್ಯರ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ." },
  visitDateError: { en: "Please choose date of visit.", kn: "ದಯವಿಟ್ಟು ಭೇಟಿ ದಿನಾಂಕವನ್ನು ಆಯ್ಕೆಮಾಡಿ." },
  roomTypeError: { en: "Please select room type.", kn: "ದಯವಿಟ್ಟು ಕೊಠಡಿ ಪ್ರಕಾರವನ್ನು ಆಯ್ಕೆಮಾಡಿ." },
  messageError: { en: "Please enter your message.", kn: "ದಯವಿಟ್ಟು ನಿಮ್ಮ ಸಂದೇಶವನ್ನು ನಮೂದಿಸಿ." },
  success: { en: "Thank you. Your message has been received. Our office will get back to you shortly.", kn: "ಧನ್ಯವಾದಗಳು. ನಿಮ್ಮ ಸಂದೇಶ ಸ್ವೀಕರಿಸಲಾಗಿದೆ. ನಮ್ಮ ಕಚೇರಿ ಶೀಘ್ರದಲ್ಲೇ ನಿಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸುತ್ತದೆ." },
  submitError: { en: "Unable to submit your message.", kn: "ನಿಮ್ಮ ಸಂದೇಶವನ್ನು ಸಲ್ಲಿಸಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ." },
  departments: { en: "Departments", kn: "ವಿಭಾಗಗಳು" },
  rightDesk: { en: "Reach the right desk", kn: "ಸರಿಯಾದ ವಿಭಾಗವನ್ನು ಸಂಪರ್ಕಿಸಿ" },
  planVisit: { en: "Plan Your Visit", kn: "ನಿಮ್ಮ ಭೇಟಿಯನ್ನು ಯೋಜಿಸಿ" },
  reachingMatha: { en: "Reaching Sode Matha", kn: "ಸೋದೆ ಮಠಕ್ಕೆ ತಲುಪುವ ಮಾರ್ಗ" },
};

const visitCards = [
  {
    icon: Plane,
    title: { en: "By Air", kn: "ವಿಮಾನ ಮೂಲಕ" },
    desc: {
      en: "Nearest airport: Mangaluru (approx. 130 km) or Hubballi (approx. 150 km). Regular taxi services available.",
      kn: "ಹತ್ತಿರದ ವಿಮಾನ ನಿಲ್ದಾಣ: ಮಂಗಳೂರು (ಸುಮಾರು 130 ಕಿ.ಮೀ.) ಅಥವಾ ಹುಬ್ಬಳ್ಳಿ (ಸುಮಾರು 150 ಕಿ.ಮೀ.). ನಿಯಮಿತ ಟ್ಯಾಕ್ಸಿ ಸೇವೆಗಳು ಲಭ್ಯ.",
    },
  },
  {
    icon: Train,
    title: { en: "By Train", kn: "ರೈಲು ಮೂಲಕ" },
    desc: {
      en: "Nearest railway station: Sirsi (Kumta line) or Shimoga. Onwards by road.",
      kn: "ಹತ್ತಿರದ ರೈಲು ನಿಲ್ದಾಣ: ಸಿರ್ಸಿ (ಕುಮಟಾ ಮಾರ್ಗ) ಅಥವಾ ಶಿವಮೊಗ್ಗ. ಅಲ್ಲಿಂದ ರಸ್ತೆ ಮಾರ್ಗವಾಗಿ ಪ್ರಯಾಣಿಸಬಹುದು.",
    },
  },
  {
    icon: Car,
    title: { en: "By Road", kn: "ರಸ್ತೆ ಮೂಲಕ" },
    desc: {
      en: "Well-connected by state highways. Buses from Bengaluru, Mangaluru, Hubballi and Shimoga.",
      kn: "ರಾಜ್ಯ ಹೆದ್ದಾರಿಗಳ ಮೂಲಕ ಉತ್ತಮ ಸಂಪರ್ಕವಿದೆ. ಬೆಂಗಳೂರು, ಮಂಗಳೂರು, ಹುಬ್ಬಳ್ಳಿ ಮತ್ತು ಶಿವಮೊಗ್ಗದಿಂದ ಬಸ್‌ಗಳು ಲಭ್ಯ.",
    },
  },
  {
    icon: Info,
    title: { en: "Accommodation", kn: "ವಸತಿ" },
    desc: {
      en: "Devotee guest houses on-site. Advance booking recommended for festival periods.",
      kn: "ಭಕ್ತರಿಗಾಗಿ ಆವರಣದಲ್ಲಿ ಅತಿಥಿ ಗೃಹಗಳಿವೆ. ಉತ್ಸವದ ದಿನಗಳಲ್ಲಿ ಮುಂಗಡ ಕಾಯ್ದಿರಿಸುವುದು ಉತ್ತಮ.",
    },
  },
  {
    icon: Camera,
    title: { en: "Photography", kn: "ಛಾಯಾಗ್ರಹಣ" },
    desc: {
      en: "Photography permitted in outer premises. Please refrain inside the sanctum.",
      kn: "ಹೊರ ಆವರಣದಲ್ಲಿ ಛಾಯಾಗ್ರಹಣಕ್ಕೆ ಅನುಮತಿ ಇದೆ. ಗರ್ಭಗುಡಿಯಲ್ಲಿ ದಯವಿಟ್ಟು ಛಾಯಾಗ್ರಹಣ ಮಾಡಬೇಡಿ.",
    },
  },
  {
    icon: MapPin,
    title: { en: "Dress Code", kn: "ವಸ್ತ್ರ ಸಂಹಿತೆ" },
    desc: {
      en: "Traditional attire is respectful. Modest clothing appreciated in the temple.",
      kn: "ಸಾಂಪ್ರದಾಯಿಕ ಉಡುಗೆ ಗೌರವಯುತವಾಗಿದೆ. ದೇವಸ್ಥಾನದಲ್ಲಿ ವಿನಯಪೂರ್ಣ ವಸ್ತ್ರ ಧರಿಸುವುದು ಪ್ರಶಂಸನೀಯ.",
    },
  },
];

const Contact = () => {
  const { t, lang } = useLang();
  const L = (copy) => (copy && copy[lang]) || copy.en;
  const [form, setForm] = useState({ name: "", email: "", phone: "", category: "", members: "", visitDate: "", roomType: "", subject: "", message: "" });
  const [roomTypes, setRoomTypes] = useState([]);
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    let alive = true;

    fetchRoomTypes()
      .then((types) => {
        if (alive) setRoomTypes(types);
      })
      .catch(() => {
        if (alive) setRoomTypes([]);
      });

    return () => { alive = false; };
  }, []);

  const validate = () => {
    const nextErrors = {};
    if (!form.name.trim()) nextErrors.name = L(COPY.nameError);
    if (form.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) nextErrors.email = L(COPY.emailError);
    if (!/^\d{10}$/.test(form.phone)) nextErrors.phone = L(COPY.phoneError);
    if (!form.category) nextErrors.category = L(COPY.categoryError);
    if (form.category === "1") {
      if (!form.members || Number(form.members) < 1) nextErrors.members = L(COPY.membersError);
      if (!form.visitDate) nextErrors.visitDate = L(COPY.visitDateError);
      if (!form.roomType) nextErrors.roomType = L(COPY.roomTypeError);
    }
    if (!form.message.trim()) nextErrors.message = L(COPY.messageError);
    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const inputClass = "bg-transparent border-b border-[#D4AF37]/40 py-2.5 outline-none focus:border-[#B65A14] text-[#3B2A1A] placeholder:text-[#3B2A1A]/50";
  const selectClass = (value) => `bg-transparent border-b border-[#D4AF37]/40 py-2.5 outline-none focus:border-[#B65A14] ${value ? "text-[#3B2A1A]" : "text-[#3B2A1A]/50"}`;

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setSubmitting(true);
    try {
      await createContactInquiry({
        name: form.name,
        emailAddress: form.email,
        phone: form.phone ? `91${form.phone}` : "",
        remarks: [form.subject, form.message].filter(Boolean).join("\n\n"),
        type: Number(form.category),
        occupancy: form.category === "1" ? Number(form.members) : "",
        bookingDate: form.category === "1" ? dateToEpoch(form.visitDate) : "",
        roomTypeId: form.category === "1" ? Number(form.roomType) : "",
      });
      toast.success(L(COPY.success));
      setForm({ name: "", email: "", phone: "", category: "", members: "", visitDate: "", roomType: "", subject: "", message: "" });
      setErrors({});
    } catch (error) {
      toast.error(error.message || L(COPY.submitError));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <PageLayout>
      <PageHero
        eyebrow={t("contact.hero.eyebrow")}
        title={'Contact Us'}
        subtitle={''}
        image={IMG.templeCorridor}
      />

      {/* Contact info */}
      <section className="py-16" data-testid="contact-info">
        <div className="max-w-7xl mx-auto px-4 lg:px-8 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {[
            { icon: MapPin, title: t("common.address"), value: SITE.address },
            { icon: Phone, title: t("common.phone"), value: [SITE.phone, SITE.phoneAlt], href: `tel:${SITE.phone.replace(/\s/g, "")}` },
            { icon: Mail, title: t("common.email"), value: SITE.email, href: `mailto:${SITE.email}` },
            { icon: Clock, title: t("common.officeHours"), value: t("contact.officeHoursValue") },
          ].map((c) => (
            <div key={c.title} className="bg-[#FBF7F0] border border-[#D4AF37]/25 rounded-2xl p-7 card-lift" data-testid={`contact-${c.title.toLowerCase()}`}>
              <div className="w-12 h-12 rounded-xl bg-[#B65A14] text-[#D4AF37] flex items-center justify-center mb-4">
                <c.icon className="w-5 h-5" />
              </div>
              <div className="overline text-[#B65A14]">{c.title}</div>
              {c.href ? (
                <a href={c.href} className="mt-2 block text-base text-[#3B2A1A] hover:text-[#B65A14]">
                  {Array.isArray(c.value) ? (
                    <div className="space-y-1">
                      {c.value.map((value) => (
                        <div key={value}>{value}</div>
                      ))}
                    </div>
                  ) : (
                    c.value
                  )}
                </a>
              ) : (
                <div className="mt-2 text-base text-[#3B2A1A]">
                  {Array.isArray(c.value) ? (
                    <div className="space-y-1">
                      {c.value.map((value) => (
                        <div key={value}>{value}</div>
                      ))}
                    </div>
                  ) : (
                    c.value
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* Form + Map */}
      <section className="pb-24" data-testid="contact-form-section">
        <div className="max-w-7xl mx-auto px-4 lg:px-8 grid lg:grid-cols-2 gap-10">
          <div>
            <SectionHeading eyebrow={t("contact.form.eyebrow")} title={t("contact.form.title")} />
            <form onSubmit={onSubmit} className="mt-8 space-y-4 bg-[#FBF7F0] border border-[#D4AF37]/25 rounded-2xl p-8" data-testid="contact-form">
              <div className="grid sm:grid-cols-2 gap-4">
                <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder={`${L(COPY.name)} *`} className={inputClass} data-testid="form-name" />
                <input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder={L(COPY.email)} className={inputClass} data-testid="form-email" />
              </div>
              {(errors.name || errors.email) && <div className="grid sm:grid-cols-2 gap-4 text-xs text-[#A81F1F]"><div>{errors.name}</div><div>{errors.email}</div></div>}
              <div className="grid sm:grid-cols-2 gap-4">
                <input
                  required
                  value={form.phone}
                  onChange={(e) => setForm({ ...form, phone: numbersOnly(e.target.value).slice(0, 10) })}
                  onKeyDown={(e) => { if (e.key.length === 1 && !/\d/.test(e.key)) e.preventDefault(); }}
                  inputMode="numeric"
                  maxLength={10}
                  placeholder={`${L(COPY.phone)} *`}
                  className={inputClass}
                  data-testid="form-phone"
                />
                <select required value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value, members: "", visitDate: "", roomType: "" })} className={selectClass(form.category)} data-testid="form-category">
                  <option value="">{L(COPY.selectCategory)} *</option>
                  <option value="1">{L(COPY.roomBooking)}</option>
                  <option value="2">{L(COPY.onlineSeva)}</option>
                  <option value="3">{L(COPY.generalQuery)}</option>
                </select>
              </div>
              {(errors.phone || errors.category) && <div className="grid sm:grid-cols-2 gap-4 text-xs text-[#A81F1F]"><div>{errors.phone}</div><div>{errors.category}</div></div>}
              {form.category === "1" && (
                <>
                  <div className="grid sm:grid-cols-1 gap-4">
                    <input type="number" min="1" value={form.members} onChange={(e) => setForm({ ...form, members: e.target.value })} placeholder={`${L(COPY.members)} *`} className={inputClass} data-testid="form-members" />
                    <input
                      type={form.visitDate ? "date" : "text"}
                      min={todayISO()}
                      value={form.visitDate}
                      onFocus={(e) => { e.currentTarget.type = "date"; }}
                      onBlur={(e) => { if (!e.currentTarget.value) e.currentTarget.type = "text"; }}
                      onChange={(e) => setForm({ ...form, visitDate: e.target.value })}
                      placeholder={`${L(COPY.visitDate)} *`}
                      className={inputClass}
                      data-testid="form-visit-date"
                    />
                    <select value={form.roomType} onChange={(e) => setForm({ ...form, roomType: e.target.value })} className={selectClass(form.roomType)} data-testid="form-room-type">
                      <option value="">{L(COPY.roomType)} *</option>
                      {roomTypes.map((roomType) => (
                        <option key={roomType.id} value={roomType.id}>{roomType.name}</option>
                      ))}
                    </select>
                  </div>
                  {(errors.members || errors.visitDate || errors.roomType) && <div className="grid sm:grid-cols-3 gap-4 text-xs text-[#A81F1F]"><div>{errors.members}</div><div>{errors.visitDate}</div><div>{errors.roomType}</div></div>}
                </>
              )}
              <input
                value={form.subject}
                onChange={(e) => setForm({ ...form, subject: e.target.value.slice(0, SUBJECT_MAX_LENGTH) })}
                maxLength={SUBJECT_MAX_LENGTH}
                placeholder={L(COPY.subject)}
                className={`w-full ${inputClass}`}
                data-testid="form-subject"
              />
              <textarea
                required
                rows={5}
                value={form.message}
                onChange={(e) => setForm({ ...form, message: e.target.value.slice(0, MESSAGE_MAX_LENGTH) })}
                maxLength={MESSAGE_MAX_LENGTH}
                placeholder={`${L(COPY.message)} *`}
                className={`w-full ${inputClass} resize-none`}
                data-testid="form-message"
              />
              {errors.message && <p className="text-xs text-[#A81F1F]">{errors.message}</p>}
              <button type="submit" disabled={submitting} className="inline-flex items-center gap-2 rounded-full bg-[#B65A14] text-[#FBF7F0] px-6 py-3 text-sm font-semibold hover:bg-[#8F4610] disabled:bg-[#B65A14]/50 disabled:cursor-not-allowed transition" data-testid="form-submit">
                <Send className="w-4 h-4" /> {submitting ? L(COPY.sending) : L(COPY.sendMessage)}
              </button>
            </form>
          </div>
          <div>
            <SectionHeading eyebrow={t("contact.map.eyebrow")} title={t("contact.map.title")} />
            <div className="mt-8 rounded-2xl overflow-hidden border border-[#D4AF37]/30 shadow-xl">
              <iframe
                src={SITE.mapEmbed}
                width="100%"
                height="380"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Sri Sode Vadiraja Matha map"
                data-testid="contact-map"
              />
            </div>
          </div>
        </div>
      </section>

      <SectionDivider variant="lotus" />

      {/* Departments */}
      {/* <section className="py-16 bg-sand-texture" data-testid="departments">
        <div className="max-w-7xl mx-auto px-4 lg:px-8">
          <SectionHeading eyebrow={L(COPY.departments)} title={L(COPY.rightDesk)} align="center" />
          <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {departments.map((d) => (
              <div key={d.name.en} className="bg-[#FBF7F0] border border-[#D4AF37]/25 rounded-2xl p-6 card-lift" data-testid={`dept-${d.name.en.toLowerCase().replace(/\W/g, "-")}`}>
                <div className="font-serif-display text-lg text-[#3B2A1A]">{L(d.name)}</div>
                <div className="mt-3 text-sm space-y-1.5">
                  <a href={`mailto:${d.email}`} className="flex items-center gap-2 text-[#B65A14] hover:text-[#8F4610]"><Mail className="w-4 h-4" /> {d.email}</a>
                  <a href={`tel:${d.phone}`} className="flex items-center gap-2 text-[#B65A14] hover:text-[#8F4610]"><Phone className="w-4 h-4" /> {d.phone}</a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Visit planning */}
      <section className="py-16" data-testid="visit-planning">
        <div className="max-w-7xl mx-auto px-4 lg:px-8">
          <SectionHeading eyebrow={L(COPY.planVisit)} title={L(COPY.reachingMatha)} align="center" />
          <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {visitCards.map((v) => (
              <div key={v.title.en} className="bg-[#FBF7F0] border border-[#D4AF37]/25 rounded-2xl p-7 card-lift">
                <div className="w-12 h-12 rounded-xl bg-[#F2E7D5] text-[#B65A14] flex items-center justify-center mb-4"><v.icon className="w-5 h-5" /></div>
                <div className="font-serif-display text-lg text-[#3B2A1A]">{L(v.title)}</div>
                <p className="mt-2 text-sm text-[#3B2A1A]/80 leading-relaxed">{L(v.desc)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default Contact;
